class StorefrontApiClient {
    constructor() {
        this.storeDomain = window.purpleTheme.config.domainStorefrontShopify;
        this.publicAccessToken = window.purpleTheme.config.publicAccessTokenStorefront;
        this.apiVersion = window.purpleTheme.config.storefrontApiVersion;

        this.endpoint = `https://${this.storeDomain}/api/${this.apiVersion}/graphql.json`;
        this.headers = {
            'Content-Type': 'application/json',
            'X-Shopify-Storefront-Access-Token': this.publicAccessToken
        };
    }

    async execute(query, variables = {}) {
        const response = await fetch(this.endpoint, {
            method: 'POST',
            headers: this.headers,
            body: JSON.stringify({ query, variables })
        });

        if (!response.ok) {
            throw new Error('GraphQL request failed');
        }

        return await response.json();
    }
}

class CartService {

    async applyDiscount(cartId, discountCode) {
        // Backwards compatibility for cached scripts
        return this.updateDiscountCodes(cartId, [discountCode]);
    }

    async updateDiscountCodes(cartId, discountCodesArray) {
        if (!window.purpleTheme.config.storefrontClient.client) return;

        const apiClient = window.purpleTheme.config.storefrontClient.client;

        const mutation = `
            mutation cartDiscountCodesUpdate($cartId: ID!, $discountCodes: [String!]!) {
                cartDiscountCodesUpdate(cartId: $cartId, discountCodes: $discountCodes) {
                    cart {
                        id
                        cost {
                            subtotalAmount { amount currencyCode }
                            totalAmount { amount currencyCode }
                        }
                        discountCodes { code applicable }
                        discountAllocations {
                            discountedAmount { amount }
                        }
                        lines(first: 250) {
                            edges {
                                node {
                                    quantity
                                    merchandise {
                                        ... on ProductVariant {
                                            price { amount }
                                        }
                                    }
                                    discountAllocations {
                                        discountedAmount { amount }
                                    }
                                }
                            }
                        }
                    }
                    userErrors { field message }
                }
            }
        `;

        const variables = {
            cartId,
            discountCodes: discountCodesArray
        };

        return await apiClient.execute(mutation, variables);
    }
}